<template>
	<div class="infoHeader">
		<div class="fixation">
			<div class="logo">
				<router-link to="/"><img src="../../../assets/index-logo.png" alt=""></router-link>
			</div>
			<div class="title">
				<i :class="icon"></i>
				{{title}}
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'infoHeader',
		props: ['title','icon'],
		data() {
			return {};
		},
		methods: {},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.infoHeader {
		height: 110px;
		box-shadow: 0px 10px 10px @vue-border-color;
	}

	.fixation {
		display: flex;
		justify-content: space-between;

		.logo,
		.title {
			height: 100%;
			display: flex;
			align-items: center;
		}
		
		.title {
			font-size: @vue-font-size-lg;
			color: @vue-text-color-red;

			i {
				margin-right: @vue-spacing-row-sm;
				margin-top: @vue-spacing-col-sm / 2;
			}
		}
	}
</style>
